module.exports = __webpack_public_path__ + "img/car-02.248ffa4b.svg";